import React from 'react';
import { Tabs as CustomTabs, Tab } from '@appkit4/react-components/tabs';

export type TabConfig = {
    label: string;
    value: string;
};

type TabsProps = {
    tabs: TabConfig[];
    type?: 'underline' | 'filled';
    defaultActiveIndex?: number;
    onChange?: (index: number, value: string) => void;
};

const Tabs: React.FC<TabsProps> = ({
    tabs,
    type = 'underline',
    defaultActiveIndex = 0,
    onChange,
}) => {
    const [activeIndex, setActiveIndex] = React.useState(defaultActiveIndex);

    const handleTabChange = (index: number, value: string) => {
        setActiveIndex(index);
        if (onChange) onChange(index, value);
    };

    return (
        <CustomTabs
            type={type}
            activeIndex={activeIndex}
            onTabChange={handleTabChange}
        >
            {tabs.map((tab) => (
                <Tab key={tab.value} label={tab.label} value={tab.value} />
            ))}
        </CustomTabs>
    );
};

export default Tabs;
